
import { useDrawCard } from "@/stores/drawCard";
import { defineComponent } from "vue";
import { cardImageMapper, cardImageMapperIf } from "@/services/cardImageMapper";
export default defineComponent({
  name: "CardScreen",
  setup() {
    const drawCards = useDrawCard();
    const back = cardImageMapper["back"];
    const cardImage = (card: keyof cardImageMapperIf) => {
      return cardImageMapper[card];
    };

    return {
      drawCards,
      cardImageMapper,
      back,
      cardImage,
    };
  },
});
